import produce from 'immer';

// UTILS
import { toSelect } from 'utils/genericFunctions';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, Classificacoes } from './types';

export const INITIAL_STATE: Classificacoes = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): Classificacoes {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CLASSIFICACOES_REQUEST: {
				break;
			}
			case Types.CLASSIFICACOES_SUCCESS: {
				draft.status = action.payload.status;

				if (action.payload.data) {
					const select = toSelect(action.payload.data, 'descricao', 'codigo');
					draft.data = select;
				} else {
					draft.data = [];
				}

				break;
			}
			case Types.CLASSIFICACOES_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CLASSIFICACOES_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
